import transitions from './Transitions.scss';

import React from 'react';

import { CSSTransition } from 'react-transition-group';
import { AccordionItemId, OpenSections } from '../models';

interface AccordionBodyProps {
  children: React.ReactNode;
  itemId: AccordionItemId;
  openSections: OpenSections;
  className?: string;
  animationModifier?: number;
}

interface AccordionBodyState {
  isTransitioning: boolean;
}

const initialState: AccordionBodyState = {
  isTransitioning: false,
};

class AccordionBody extends React.Component<AccordionBodyProps, AccordionBodyState> {
  readonly state: AccordionBodyState = initialState;

  setTransitioning = () => {
    this.setState({ isTransitioning: true });
  };

  unsetTransitioning = () => {
    this.setState({ isTransitioning: false });
  };

  render() {
    const { openSections, itemId, children, className= '' } = this.props;
    const { isTransitioning } = this.state;

    const isOpen = !!openSections[itemId];

    const accessibilityAttr: React.HTMLAttributes<HTMLDivElement> = {
      'id': `accordion__body__${`${itemId}`}`,
      'aria-controls': `accordion__title__${`${itemId}`}`,
      'aria-labelledby': `accordion__label__${`${itemId}`}`,
      'aria-hidden': !isOpen && !isTransitioning,
    };

    return (
      <CSSTransition
        in={isOpen}
        // this is a safety timeout, if the transition event doesn't
        timeout={1480}
        classNames={{
          enter: transitions.enter,
          enterDone: transitions.enterDone,
          exit: transitions.exit,
          exitActive: transitions.exitActive,
        }}
        onEnter={this.setTransitioning}
        onEntering={this.useNodeScrollHeight}
        onEntered={this.clearNodeScrollHeight}
        onExit={this.useNodeScrollHeight}
        onExiting={this.clearNodeScrollHeight}
        onExited={this.unsetTransitioning}
      >
        <div {...accessibilityAttr} className={className || ''} style={!isOpen && !isTransitioning ? { visibility: 'hidden', height: 0, padding: 0 } : {}}>
          {children}
        </div>
      </CSSTransition>
    );
  }

  private useNodeScrollHeight = (node: HTMLElement) => {
    const { animationModifier = 1 } = this.props;
    node.style.maxHeight = `${node.scrollHeight * animationModifier}px`;
  };

  private clearNodeScrollHeight(node: HTMLElement) {
    node.style.maxHeight = '';
  }
}

export { AccordionBodyProps, AccordionBody } ;
